import { render } from "./FactsSectionComponent.vue?vue&type=template&id=d5d42fb4&scoped=true"
import script from "./FactsSectionComponent.vue?vue&type=script&lang=js"
export * from "./FactsSectionComponent.vue?vue&type=script&lang=js"

import "./FactsSectionComponent.vue?vue&type=style&index=0&id=d5d42fb4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d5d42fb4"]])

export default __exports__